import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { ButtonService } from '../../../services';
import { ButtonSet, Button } from '../../../models';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import {
  AddButtonSetDialog,
  AddButtonDialog,
  EditButtonDialog,
  EditButtonSetDialog
} from '../../dialogs';

@Component({
  selector: 'buttons-editor',
  templateUrl: './buttons-editor.component.html',
  styleUrls: ['./buttons-editor.component.css']
})
export class ButtonsEditorComponent implements OnInit {
  buttonSets: ButtonSet[];
  selectedButtonSet: ButtonSet;
  userId: string;
  loggedIn = false;
  // hasButtonSets = false;
  opened = true;

  displayedColumns = ['name', /*'type', "color",*/ 'lead', 'lag', 'commands'];
  dataSource: MatTableDataSource<Button> = new MatTableDataSource([]);

  constructor(
    private buttonService: ButtonService,
    public dialog: MatDialog,
    private authService: AngularFireAuth
  ) {}

  ngOnInit() {
    this.authService.authState.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        this.buttonService.getForUser(this.userId).subscribe(buttonSets => {
          this.buttonSets = buttonSets;
          if (buttonSets && buttonSets.length > 0) {
            this.selectedButtonSet = buttonSets[0];
          }
        });
      }
    });
  }

  newButtonSet(): void {
    const dialogRef = this.dialog.open(AddButtonSetDialog);
  }

  onSelectButtonSet(buttonSet: ButtonSet): void {
    if (!buttonSet.buttons) {
      console.info('adding buttons');
      buttonSet.buttons = [];
    }

    this.dataSource.data = buttonSet.buttons;
    this.selectedButtonSet = buttonSet;
  }

  deleteButtonSet(buttonSet: ButtonSet): void {
    const response = confirm('Are you sure you want to delete this Button Set?');

    if (response) {
      console.info('[ButtonSEditor] deleting buttonSet', buttonSet);
      this.buttonService.delete(buttonSet.id);
      this.selectedButtonSet = undefined;
      this.dataSource.data = [];
      console.info('deleted', buttonSet);
      // this.selectedButtonSet = undefined;
    }
  }

  editButtonSet(buttonSet: ButtonSet): void {
    const dialogRef = this.dialog.open(EditButtonSetDialog, {
      data: buttonSet,
      width: '340px',
      height: '400px'
    });

    dialogRef.afterClosed().subscribe((bs: ButtonSet) => {
      console.info('[ButtonSEditor] edited buttonSet', bs);
    });
  }

  compareColor(elementColor: string, compareColor: string): boolean {
    return elementColor && compareColor && elementColor.toLowerCase() === compareColor.toLowerCase();
  }

  addButton(buttonSet: ButtonSet): void {
    const dialogRef = this.dialog.open(AddButtonDialog, {
      data: buttonSet,
      width: '340px',
      height: '400px'
    });

    dialogRef.afterClosed().subscribe((bs: ButtonSet) => {
      if (bs !== undefined) {
        this.selectedButtonSet = bs;
        this.dataSource.data = bs.buttons;
      }
    });
  }

  editButton(button: Button): void {
    const dialogRef = this.dialog.open(EditButtonDialog, {
      width: '340px',
      height: '400px'
    });
    dialogRef.componentInstance.button = button;
    dialogRef.componentInstance.buttonSet = this.selectedButtonSet;

    dialogRef.afterClosed().subscribe((buttonSet: ButtonSet) => {
      if (buttonSet !== undefined) {
        this.selectedButtonSet = buttonSet;
        this.dataSource.data = buttonSet.buttons;
      }
    });
  }

  addDefaultButtons(buttonSet: ButtonSet): void {
    const response = confirm(
      'This will reset buttons for this Button Set to the default buttons.  Press OK to Continue.'
    );
    if (response) {
      buttonSet.buttons = this.buttonService.getDefaultButtonSet().buttons;
      this.buttonService.update(buttonSet);
      this.dataSource.data = buttonSet.buttons;
    }
  }

  deleteButton(button: Button): void {
    const response = confirm('Are you sure you want to delete this button?');
    if (response) {
      const newButtons = this.selectedButtonSet.buttons.filter(b => b.name !== button.name);
      this.selectedButtonSet.buttons = newButtons;

      this.buttonService
        .update(this.selectedButtonSet)
        .subscribe(() => (this.dataSource.data = newButtons));
    }
  }
}
